import { Box, Text, InfoIcon, ToggleSwitch } from '@wix/design-system';
import t__default, { useContext } from 'react';
import { ZIndexContext } from 'ricos-context';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';

var css_248z = "[dir] .NRJ5S{margin-bottom:var(--ricos-toggle-button-margin-bottom,0);margin-top:var(--ricos-toggle-button-margin-top,0)}";
var classes = {"root":"NRJ5S"};
styleInject(css_248z);

const ToggleButton = ({
  checked,
  onChange,
  title,
  infoContent,
  dataHook
}) => {
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ t__default.createElement(Box, { verticalAlign: "middle", align: "space-between", className: classes.root }, infoContent ? /* @__PURE__ */ t__default.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ t__default.createElement(Text, { size: "small" }, title), /* @__PURE__ */ t__default.createElement(
    InfoIcon,
    {
      size: "small",
      content: infoContent,
      tooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        zIndex: zIndexService.getZIndex("TOOLTIP")
      }
    }
  )) : /* @__PURE__ */ t__default.createElement(Text, { size: "small" }, title), /* @__PURE__ */ t__default.createElement(ToggleSwitch, { checked, onChange, dataHook }));
};

export { ToggleButton };
//# sourceMappingURL=toggle-button.js.map
